import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=6b2fe880&scoped=true"
import script from "./LocationTab.ts?vue&type=script&lang=ts&external"
export * from "./LocationTab.ts?vue&type=script&lang=ts&external"
import style0 from "./LocationTab.vue?vue&type=style&index=0&id=6b2fe880&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2fe880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2fe880')) {
      api.createRecord('6b2fe880', component.options)
    } else {
      api.reload('6b2fe880', component.options)
    }
    module.hot.accept("./LocationTab.vue?vue&type=template&id=6b2fe880&scoped=true", function () {
      api.rerender('6b2fe880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/tabs/LocationTab/LocationTab.vue"
export default component.exports